import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function add({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <path
        fill="none"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v12M18 12H6"
      />
    </svg>
  );
}

export default add;
